module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.$t(("tasks." + (_vm.task.identifier) + ".label")),
      "moduleIdentifier": _vm.task.module.identifier
    }
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.task.status,
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.$t(("batch.statuses." + (_vm.task.status) + ".label"))))]), _vm._v(" "), (_vm.task.status === 'pending') ? _c('button', {
    staticClass: "btn hint hint--left error btn-cancel",
    attrs: {
      "slot": "header-right",
      "data-label": "Clique aqui para cancelar tarefa"
    },
    on: {
      "click": function($event) {
        return _vm.showModal()
      }
    },
    slot: "header-right"
  }, [_c('i', {
    staticClass: "icon-blocked"
  })]) : _vm._e()]), _vm._v(" "), _c('modal-cancel', {
    on: {
      "option": function($event) {
        return _vm.cancelTask(_vm.task)
      }
    },
    model: {
      value: (_vm.cancelItemFlag),
      callback: function($$v) {
        _vm.cancelItemFlag = $$v
      },
      expression: "cancelItemFlag"
    }
  }), _vm._v(" "), (_vm.task.status === 'processing') ? _c('div', {
    staticClass: "progress-bar"
  }, [_c('progress', {
    staticClass: "progress",
    attrs: {
      "slot": "floor"
    },
    domProps: {
      "value": _vm.percent / 100
    },
    slot: "floor"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-bar-label",
    style: (("width: " + _vm.percent + "%"))
  }, [_vm._v(_vm._s(_vm.dataLabel))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "l-row vertical-flex"
  }, [(_vm.task.options) ? _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('panel', {
    attrs: {
      "title": "Opções"
    }
  }, _vm._l((Object.keys(_vm.task.options)), function(option) {
    return _c('span', {
      key: option,
      staticClass: "ds-block"
    }, [_vm._l((Object.keys(_vm.task.options[option])), function(optionDetail) {
      return (_vm.isObjectOption(option)) ? _c('span', {
        key: optionDetail,
        staticClass: "ds-block"
      }, [_c('strong', [_vm._v(_vm._s(optionDetail === 'auxiliary' ? _vm.$t(((_vm.task.options.price.type) + ".label")) : _vm.$t((option + "." + optionDetail + ".label"))) + ":")]), _vm._v("\n              " + _vm._s(_vm.$te(((_vm.task.options[option][optionDetail]) + ".label")) ?
        _vm.$t(((_vm.task.options[option][optionDetail]) + ".label")) :
        _vm.isObject(_vm.task.options[option][optionDetail]) ?
        _vm.getValues([option, optionDetail], _vm.task.options[option][optionDetail]) :
        _vm.applyMask([option, optionDetail], _vm.task.options[option][optionDetail])) + "\n            ")]) : _vm._e()
    }), _vm._v(" "), (!_vm.isObjectOption(option)) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t((option + ".label"))) + ":")]), _vm._v(" "), (option !== 'file') ? _c('span', [_vm._v("\n                " + _vm._s(_vm.$te(((_vm.task.options[option]) + ".label")) ?
      _vm.$t(((_vm.task.options[option]) + ".label")) :
      _vm.getLabel(option)) + "\n              ")]) : _c('a', {
      attrs: {
        "href": _vm.task.options[option]
      }
    }, [_c('span', {
      staticClass: "hint hint--right",
      attrs: {
        "data-label": "Baixe aqui"
      }
    }, [_vm._v("\n                  Fazer download\n                ")]), _vm._v(" "), _c('i', {
      staticClass: "icon-file-download"
    })])]) : _vm._e()], 2)
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.informationAndOptionsPanelColumns
  }, [_c('panel', {
    attrs: {
      "title": "Informações"
    }
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Criado por:")]), _vm._v(" " + _vm._s(_vm.task.user))]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Total de itens:")]), _vm._v(" " + _vm._s(_vm.task.totalItems))]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Data de criação:")]), _vm._v(" " + _vm._s(_vm.formatDate(this.task.created)))]), _vm._v(" "), (_vm.task.processing) ? _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Data de processamento:")]), _vm._v(" " + _vm._s(_vm.formatDate(this.task.processing)))]) : _vm._e(), _vm._v(" "), (_vm.task.done) ? _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Data de finalização:")]), _vm._v(" " + _vm._s(_vm.formatDate(this.task.done)))]) : _vm._e(), _vm._v(" "), (_vm.task.result && _vm.task.status === 'done') ? _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Resultado")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.taskResultIsUrl ? _vm.task.result : null,
      "download": _vm.taskResultIsUrl ? null : _vm.taskResultDownloadFileName
    },
    on: {
      "click": _vm.downloadTaskResult
    }
  }, [_c('span', {
    staticClass: "hint hint--right",
    attrs: {
      "data-label": "Baixe aqui"
    }
  }, [_vm._v("\n                Fazer download\n              ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-file-download"
  })])]) : _vm._e()])], 1)]), _vm._v(" "), (_vm.task.filters) ? _c('div', {
    staticClass: "l-row vertical-flex"
  }, [_c('div', {
    class: _vm.filtersPanelColumns
  }, [_c('panel', {
    attrs: {
      "title": "Filtros"
    }
  }, _vm._l((Object.keys(_vm.task.filters)), function(filter) {
    return _c('span', {
      staticClass: "ds-block"
    }, [(filter !== 'source') ? _c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t((filter + ".label"))) + ":")]), _vm._v("\n              " + _vm._s(_vm._f("nullableSanitize")(_vm.$te(((_vm.task.filters[filter]) + ".label")) ?
      _vm.$t(((_vm.task.filters[filter]) + ".label")) :
      _vm.isObject(_vm.task.filters[filter]) ?
      _vm.formatObject((_vm.task.filters[filter])) :
      _vm.$te(("mercadoLivre.types." + (_vm.task.filters[filter]) + ".label")) ?
      _vm.$t(("mercadoLivre.types." + (_vm.task.filters[filter]) + ".label")) :
      _vm.task.filters[filter])) + "\n            ")]) : _vm._e()])
  }), 0)], 1), _vm._v(" "), (_vm.task.filters.source) ? _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('panel', {
    attrs: {
      "title": "Filtros da fonte"
    }
  }, _vm._l((Object.keys(_vm.task.filters.source)), function(filter) {
    return _c('span', {
      staticClass: "ds-block"
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t((filter + ".label"))) + ":")]), _vm._v("\n              " + _vm._s(_vm._f("nullableSanitize")(_vm.$te(((_vm.task.filters.source[filter]) + ".label")) ?
      _vm.$t(((_vm.task.filters.source[filter]) + ".label")) :
      _vm.isObject(_vm.task.filters.source[filter]) ?
      _vm.getValues([filter], _vm.task.filters.source[filter]) :
      _vm.task.filters.source[filter])) + "\n            ")])])
  }), 0)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.task.comment) ? _c('div', {
    staticClass: "l-row vertical-flex"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('panel', {
    attrs: {
      "title": "Observações"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.task.comment) + "\n        ")])], 1)]) : _vm._e(), _vm._v(" "), _c('panel', {
    staticClass: "blue-panel",
    attrs: {
      "title": "Itens"
    }
  }, [_c('list', {
    attrs: {
      "filterTitle": "Filtro de itens",
      "loading": _vm.loadingItems,
      "total": _vm.toolBatchTaskTotalTaskItems
    },
    on: {
      "change": _vm.onChange,
      "loadMore": _vm.loadMore
    }
  }, [_c('template', {
    slot: "filters"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('identifier.label')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.identifier),
      expression: "options.identifier"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.identifier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "identifier", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('level.label')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.level),
      expression: "options.level"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "level", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "critical"
    }
  }, [_vm._v(_vm._s(_vm.$t("level.critical.label")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "warning"
    }
  }, [_vm._v(_vm._s(_vm.$t("level.warning.label")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "info"
    }
  }, [_vm._v(_vm._s(_vm.$t("level.info.label")))])])])], 1), _vm._v(" "), _vm._l((_vm.toolBatchTaskTaskItems), function(taskItem) {
    return _c('div', {
      key: taskItem,
      staticClass: "l-col-12@md"
    }, [_c('panel', [_c('div', {
      staticClass: "l-row"
    }, [_c('div', {
      staticClass: "l-col-12@md"
    }, [_c('span', {
      class: ("t-" + (taskItem.level))
    }, [_vm._v(_vm._s(taskItem.identifier) + " - " + _vm._s(taskItem.message) + " - " + _vm._s(_vm.formatDate(taskItem.created)))])])])])], 1)
  }), _vm._v(" "), (!_vm.toolBatchTaskTaskItems.length) ? _c('div', {
    staticClass: "l-col-12@md u-textCenter"
  }, [_c('panel', [_vm._v("Nenhum item encontrado")])], 1) : _vm._e()], 2)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-368ad303","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Task/Detail.vue
// module id = 3052
// module chunks = 0